/**
 * PraticaSummaryCard — F-005 Phase 4 (IMPL-P4-004).
 *
 * Card di riepilogo pratica nel detail-view cliente. V1: mostra il
 * `codicePratica` e (se presenti nei `datiStrutturati`) tipologia +
 * locatario in una `<dl>` accessibile.
 *
 * Phase 5 estenderà la card con tutti i campi del wizard.
 */
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import type { PraticaDetailResponse } from '../lib/cliente-pratiche-client';

interface PraticaSummaryCardProps {
  pratica: PraticaDetailResponse['pratica'];
}

function readString(data: Record<string, unknown>, key: string): string | null {
  const v = data[key];
  return typeof v === 'string' && v.length > 0 ? v : null;
}

export function PraticaSummaryCard({ pratica }: PraticaSummaryCardProps) {
  const data = pratica.datiStrutturati ?? {};
  const tipologia = readString(data, 'tipologiaContratto');
  const locatore = (data['locatore'] as Record<string, unknown> | undefined) ?? null;
  let locatoreNome: string | null = null;
  if (locatore) {
    const denominazione = readString(locatore, 'denominazione');
    if (denominazione) {
      locatoreNome = denominazione;
    } else {
      const composed = [
        readString(locatore, 'nome'),
        readString(locatore, 'cognome'),
      ]
        .filter(Boolean)
        .join(' ');
      locatoreNome = composed.length > 0 ? composed : null;
    }
  }

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-base">Riepilogo pratica</CardTitle>
      </CardHeader>
      <CardContent>
        <dl className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm md:grid-cols-3">
          <div>
            <dt className="text-muted-foreground">Codice</dt>
            <dd className="font-mono font-medium">{pratica.codicePratica}</dd>
          </div>
          {tipologia && (
            <div>
              <dt className="text-muted-foreground">Tipologia</dt>
              <dd className="font-medium">{tipologia}</dd>
            </div>
          )}
          {locatoreNome && (
            <div>
              <dt className="text-muted-foreground">Locatore</dt>
              <dd className="font-medium">{locatoreNome}</dd>
            </div>
          )}
        </dl>
      </CardContent>
    </Card>
  );
}
